import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does 3D mobile game development cost?",
    answer: `<p>Developing a ‘battle-royale’ game like PUBG or Rules of Survival requires investment that can be as low as $25,000 and as high as $250,000. It involves extensive hard work from a competent team of designers skilled in designing 3D games, developing them, and the application of the best visual effects.</p>`,
  },
  {
    question: "How to hire the best 3D mobile game development company?",
    answer: `<p>You need to check and analyze online websites. It's the quickest and easiest method of hiring top app developers.</p> <p>Many websites, such as Clutch, Mobile App Daily, GoodFirms, and others, display the global list of top companies that develop software and apps.</p>`,
  },
  {
    question: "What are the top 3D game development engines in 2024?",
    answer: `<p>In 2024, Unity, Unreal Engine, Godot Engine, GameMaker Studio, Construct 3, and Open 3D Engine will be the most popular mobile game engines.</p>`,
  },
  {
    question: "What types of games do you specialize in developing?",
    answer: `<p>Among the many types of games that TekRevol excels at developing are multiplayer games, role-playing games (RPGs), simulation games, sports games, action games, adventure games, and strategy games.</p>`,
  },
  {
    question: "How long will it take to develop a game?",
    answer: `<p>Medium-complexity genres, such as action/adventure or sports, typically require more time, with timetables spanning from 6 to 18 months. However, the longest development period is linked to complex mobile games, such as MMORPGs and RPGs, which can take up to five years to complete before they are ready for sale.</p>`,
  },
  {
    question: "How can I get started with your 3D game development services?",
    answer: `<p>There are various ways through which one can begin a 3D game development project with TekRevol, these include; Emailing our team at TekRevol through the contact form provided on our website and Calling TekRevol on either of the numbers provided on the website.</p>`,
  },
  {
    question: "What tech stack is needed for 3D game development?",
    answer: `<p>Currently, Unity is the 3D engine used for interactive applications, games, virtual reality, and augmented reality applications in 90% of cases.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#f8f8f8" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>3D Game</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
